module.exports = __webpack_public_path__ + "static/img/usdt-to-address.bb448be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/usdt-to-address.png
// module id = EQj9
// module chunks = 1